import { openBlock as c, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M13 7.5h-3v-1h3v1Zm-3 2h3v-1h-3v1ZM4.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0 2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Z" }, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.627 13.65a.75.75 0 0 0 .746 0c1.499-.859 3.447-.781 5.007-.397 1.09.27 2.37-.487 2.37-1.771v-7.17c0-.593-.309-1.224-.94-1.51-1.205-.547-2.538-.645-3.745-.478-1.156.16-2.25.572-3.065 1.131-.815-.56-1.909-.97-3.065-1.131-1.207-.167-2.54-.069-3.745.478-.631.286-.94.917-.94 1.51v7.17c0 1.284 1.28 2.04 2.37 1.771 1.56-.384 3.508-.462 5.007.398Zm3.644-9.84c.993-.138 2.028-.046 2.92.358.007.003.019.01.032.033a.224.224 0 0 1 .027.11v7.17c0 .084-.04.172-.141.244a.46.46 0 0 1-.37.072c-1.403-.346-3.269-.519-4.989.053V4.849c0-.04.008-.07.017-.089.007-.016.013-.02.013-.02.599-.431 1.495-.792 2.491-.93Zm-4.038.95a.216.216 0 0 1 .017.089v7c-1.72-.57-3.586-.398-4.99-.052a.46.46 0 0 1-.369-.072c-.101-.072-.141-.16-.141-.243v-7.17c0-.048.013-.087.027-.111.013-.022.025-.03.032-.033.892-.404 1.927-.496 2.92-.358.996.138 1.892.499 2.49.93 0 0 .007.004.014.02Z",
  "clip-rule": "evenodd"
}, null, -1), v = [
  n,
  a
];
function d(l, r) {
  return c(), t("svg", o, [...v]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
